import { render, staticRenderFns } from "./AdministratorSecurityRoleSetter.vue?vue&type=template&id=e4e1ab4a&"
import script from "./AdministratorSecurityRoleSetter.vue?vue&type=script&lang=js&"
export * from "./AdministratorSecurityRoleSetter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports